import { cn } from "@/lib/utils";

interface ProgressProps {
  value: number;
  max: number;
  label: string;
  className?: string;
}

export function Progress({ value, max, label, className }: ProgressProps) {
  const percent = max > 0 ? Math.min(100, (value / max) * 100) : 0;

  return (
    <div
      role="progressbar"
      aria-label={label}
      aria-valuemin={0}
      aria-valuemax={max}
      aria-valuenow={value}
      className={cn("h-1 w-full overflow-hidden rounded-full bg-accent", className)}
    >
      <div
        className="h-full rounded-full bg-emerald-500 transition-[width] duration-500 ease-out"
        style={{ width: `${percent}%` }}
      />
    </div>
  );
}
